<div class="tutorial-container">
  <!-- Header -->
  <div class="tutorial-header">
    <div class="tutorial-title">
      <lucide-icon name="graduation-cap" [size]="20"></lucide-icon>
      <h2>Form Builder Tutorial</h2>
    </div>
    <button mat-icon-button (click)="close()" matTooltip="Close">
      <lucide-icon name="x" [size]="20"></lucide-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="tutorial-body">
    <!-- Left: Custom navigation list -->
    <div class="tutorial-nav">
      @for (section of sections; track section) {
        <div class="nav-section">
          <div class="section-header">
            <mat-icon>{{ section.icon }}</mat-icon>
            <strong>{{ section.title }}</strong>
          </div>
          @for (step of section.steps; track step; let i = $index) {
            <div
              class="step-item"
              [class.active]="currentStepIndex === getGlobalIndex(section, i)"
              (click)="goToStep(getGlobalIndex(section, i))"
              >
              <span class="step-number">{{ getGlobalIndex(section, i) + 1 }}</span>
              <span class="step-label">{{ step.title }}</span>
            </div>
          }
        </div>
      }
    </div>

    <!-- Right: Content Panel -->
    @if (currentStep) {
      <div class="tutorial-content">
        <!-- Section badge -->
        @if (getCurrentSection()) {
          <div class="section-badge">
            <mat-icon>{{ getCurrentSection().icon }}</mat-icon>
            {{ getCurrentSection().title }}
          </div>
        }
        <!-- Step title -->
        <h3 class="step-title">{{ currentStep.title }}</h3>
        <!-- Media area -->
        <div class="media-container">
          <video
            #tutorialMedia
            [src]="currentStep.mediaUrl"
            class="tutorial-media"
            autoplay
            loop
            muted
            playsinline
          ></video>
          <div class="media-placeholder">
            <lucide-icon name="circle-play" [size]="20"></lucide-icon>
            <span>Video clip: {{ currentStep.title }}</span>
          </div>
        </div>
        <!-- Description -->
        <p class="step-description">{{ currentStep.description }}</p>
        <!-- Tips -->
        @if (currentStep.tips?.length) {
          <div class="tips-section">
            <h4 class="tips-header">
              <lucide-icon name="lightbulb" [size]="20"></lucide-icon>
              Tips
            </h4>
            <ul class="tips-list">
              @for (tip of currentStep.tips; track tip) {
                <li>{{ tip }}</li>
              }
            </ul>
          </div>
        }
        <!-- Keyboard shortcut -->
        @if (currentStep.keyboardShortcut) {
          <div class="keyboard-shortcut">
            <lucide-icon name="keyboard" [size]="20"></lucide-icon>
            <span>{{ currentStep.keyboardShortcut }}</span>
          </div>
        }
        <!-- Navigation buttons -->
        <div class="navigation-buttons">
          <button
            mat-raised-button
            color="primary"
            [disabled]="currentStepIndex === 0"
            (click)="goToStep(currentStepIndex - 1)"
            >
            <lucide-icon name="arrow-left" [size]="20"></lucide-icon>
            Previous
          </button>
          <span class="step-counter">
            {{ currentStepIndex + 1 }} / {{ allSteps.length }}
          </span>
          @if (currentStepIndex < allSteps.length - 1) {
            <button
              mat-raised-button
              color="primary"
              (click)="goToStep(currentStepIndex + 1)"
              >
              Next
              <lucide-icon name="arrow-right" [size]="20"></lucide-icon>
            </button>
          }
          @if (currentStepIndex === allSteps.length - 1) {
            <button
              mat-raised-button
              color="primary"
              (click)="close()"
              >
              Done
              <lucide-icon name="check" [size]="20"></lucide-icon>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
